import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import CreateUser from './createUser'
import { ModalWrapper } from '../../../components/modalWrapper'
import { toggleProfileUiState } from '../refiActions'
import { onContinueWithoutCredit } from '../credit/creditApplicationChoice'
import { Vehicle, ProductPackage } from '../../../core/types'
import {
  selectRefiAppProfileUiState,
  selectRefiAppVehicleUiState,
  selectRefiAppCoverageUiState,
  selectCoverageStepState,
  selectCurrentRefiVehicle,
  selectCurrentProductPackageId,
  selectProductPackage,
} from '../../../reducers'
import {
  hasReduxFormChanges,
  isNamedFormDirty,
  submitNamedForm,
} from '../../../helpers/refiAppAccordionAutosave'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  uiStatus: boolean
  vehicle: Vehicle
  toggleProfileUiState: Callback
  productPackage: ProductPackage
  onContinueWithoutCredit: Callback
  vehicleUiStatus: boolean
  coverageUiStatus: boolean
  vehicleFormChanged: boolean
  coverageDetailStep: string
}

interface State {
  showTrimModal: boolean
  availableTrims: string[]
  selectedTrim: string
  currentUser: any
}

export class ProfileDetailSection extends Component<Props, State> {
  state: State = {
    showTrimModal: false,
    availableTrims: [],
    selectedTrim: '',
    currentUser: null,
  }

  handleTrimError = (user: any, trims: string[]) => {
    this.setState({
      showTrimModal: true,
      availableTrims: trims,
      currentUser: user,
      selectedTrim: trims[0],
    })
  }

  handleTrimSelection = () => {
    const { onContinueWithoutCredit } = this.props
    const { currentUser, selectedTrim } = this.state

    if (currentUser && selectedTrim) {
      onContinueWithoutCredit(currentUser, null, null, null, selectedTrim)
    }

    this.closeTrimModal()
  }

  handleTrimChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedTrim: e.target.value })
  }

  closeTrimModal = () => {
    this.setState({
      showTrimModal: false,
      availableTrims: [],
      selectedTrim: '',
      currentUser: null,
    })
  }

  submitFormByName = (
    formName: string,
    autosaveTarget: 'vehicle' | 'profile' | 'coverage' = 'profile'
  ) => {
    submitNamedForm(formName, autosaveTarget)
  }

  isCoverageFormChanged = () => {
    return isNamedFormDirty('ProductsForm')
  }

  handleSectionToggle = () => {
    const {
      uiStatus,
      vehicleUiStatus,
      vehicleFormChanged,
      toggleProfileUiState,
    } = this.props

    if (!uiStatus) {
      if (vehicleUiStatus && vehicleFormChanged) {
        this.submitFormByName('PlateVinForm', 'profile')
      }
    }

    toggleProfileUiState()
  }

  render() {
    const { uiStatus, vehicle, productPackage } = this.props
    const { showTrimModal, availableTrims, selectedTrim } = this.state

    const buttonClasses = classnames('refi-app__section-header__button', {
      'refi-app__section-header__button--open': uiStatus,
    })

    const sectionClass = classnames('', {
      'refi-app__section--open': uiStatus,
    })

    // hide Personal Details once package is booked
    if (['booked', 'paid'].includes(productPackage.status)) {
      return null
    }

    return (
      <>
        <div className={sectionClass}>
          {vehicle.id ? (
            <div
              className="refi-app__section-header"
              onClick={this.handleSectionToggle}
              data-testid="refiProfileToggle"
            >
              <h2>Personal details</h2>
              <button className={buttonClasses}>Toggle</button>
              <hr className="form__hr" />
            </div>
          ) : null}
          {uiStatus && vehicle.id ? (
            <div>
              <CreateUser
                productPackageId={productPackage.id}
                onTrimError={this.handleTrimError}
              />
              {/* Ownershipcheck may be added back later
              <OwnershipCheck />
              <OwnershipCheckFail />
              */}
            </div>
          ) : null}
        </div>

        {showTrimModal && (
          <ModalWrapper
            title="Select Vehicle Trim"
            hideModal={this.closeTrimModal}
            xclose={true}
            width="450px"
            height="260px"
          >
            <div>
              <label
                htmlFor="trim-select"
                style={{
                  display: 'block',
                  marginBottom: '10px',
                  fontWeight: 'bold',
                }}
              >
                Please select one of the available trims:
              </label>
              <select
                id="trim-select"
                value={selectedTrim}
                onChange={this.handleTrimChange}
                style={{
                  width: '100%',
                  padding: '8px',
                  fontSize: '14px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                }}
              >
                {availableTrims.map((trim) => (
                  <option key={trim} value={trim}>
                    {trim}
                  </option>
                ))}
              </select>
              <div className="modal__buttons">
                <button
                  className="button button-drive-america"
                  onClick={this.handleTrimSelection}
                >
                  Update Vehicle
                </button>
                <button
                  className="button button-drive-america"
                  onClick={this.closeTrimModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </ModalWrapper>
        )}
      </>
    )
  }
}

export const mapStateToProps = (state) => ({
  uiStatus: selectRefiAppProfileUiState(state),
  vehicleUiStatus: selectRefiAppVehicleUiState(state),
  coverageUiStatus: selectRefiAppCoverageUiState(state),
  vehicleFormChanged: hasReduxFormChanges(state, 'plateVinForm'),
  coverageDetailStep: selectCoverageStepState(state),
  vehicle: selectCurrentRefiVehicle(state),
  productPackage: selectProductPackage(
    state.productPackages,
    selectCurrentProductPackageId(state)
  ),
})

export default connect(mapStateToProps, {
  toggleProfileUiState,
  onContinueWithoutCredit,
})(ProfileDetailSection)
